import { useEffect, useState } from 'react'

// Capture beforeinstallprompt at module level — fires on page load,
// before any component mounts. Storing it here means InstallAppButton
// always gets it even if it mounts after the event fired.
let _deferred   = null
let _installed  = false
let _callbacks  = []

if (typeof window !== 'undefined') {
  _installed = window.matchMedia?.('(display-mode: standalone)').matches
    || window.navigator.standalone === true

  window.addEventListener('beforeinstallprompt', (e) => {
    // Do NOT call e.preventDefault() — lets Chrome show its native
    // mini-infobar automatically ("Add Bellason to Home screen" banner).
    // We still store the event so the button can re-trigger it.
    _deferred = e
    _callbacks.forEach(fn => fn())
  })

  window.addEventListener('appinstalled', () => {
    _deferred   = null
    _installed  = true
    _callbacks.forEach(fn => fn())
  })
}

export function useInstallPWA() {
  const [, rerender] = useState(0)

  useEffect(() => {
    const notify = () => rerender(n => n + 1)
    _callbacks.push(notify)
    return () => { _callbacks = _callbacks.filter(fn => fn !== notify) }
  }, [])

  const isIOS = typeof navigator !== 'undefined'
    && /iPad|iPhone|iPod/.test(navigator.userAgent)
    && !window.MSStream

  async function install() {
    if (!_deferred) return null
    _deferred.prompt()
    const choice = await _deferred.userChoice
    _deferred = null
    rerender(n => n + 1)
    return choice.outcome
  }

  return {
    canInstall:  !!_deferred,
    isIOS,
    isInstalled: _installed,
    install,
  }
}
